export default {
  client: "all",
  limit: 10,
  search: null,
  range: "biweekly",
  page: 1,
  type: 'sales'
}
